// PriceLabel.tsx
import * as React from "react";

type PriceLabelProps = {
  price: number;
  storeArea?: string;
  weight: number;
  className?: string;
};

/**
 * 고정 문구 템플릿
 * {area} 매장의 지역, {price} 할인가
 */
const LABELS = [
  "이만큼이 {price}원이에요!",
  "이 구성이 {price}원이에요 ❗️",
  "이 묶음이 {price}원 🙌",
  "{area} 혜택 {price}원 🥰",
  "든든한 {price}원 💪",
  "알찬 {price}원 😊",
];

export function PriceLabel({
  price,
  storeArea,
  weight,
  className,
}: PriceLabelProps) {
  const idx = weight % LABELS.length;
  let message = LABELS[idx];

  // {area} 치환
  if (message.includes("{area}")) {
    const area = storeArea || "우리동네";
    const areaName = area.split(" ")[0]; // 지역 이름만 추출 예) 수원시 영통구 -> 수원시
    message = message.replace("{area}", areaName);
  }

  // {price} 치환
  if (message.includes("{price}")) {
    const priceText = price.toLocaleString();
    message = message.replace("{price}", priceText);
  }

  return (
    <div
      className={`absolute top-0 left-0 right-0 p-4 bg-gradient-to-b from-black/90 to-transparent ${
        className || ""
      }`}
    >
      <div className="text-white text-sm font-semibold">{message}</div>
    </div>
  );
}
